import getServerSidePropsFactory from '@haaretz/s-pp-get-server-side-props';

import PpCouponPage from './PpCouponPage.page';

import type { GetServerSideProps } from 'next';

export const getServerSideProps: GetServerSideProps = getServerSidePropsFactory('coupon');
export default PpCouponPage;
